import React from "react";

const TradeAssociationsTable = ({ associations, setAssociations }) => {
  const handleChange = (index, field, value) => {
    const updated = [...associations];
    updated[index] = { ...updated[index], [field]: value };
    setAssociations(updated);
  };

  const cell = {
    border: "1px solid #000", // Black lines
    padding: "15px",
    textAlign: "left",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    borderRadius: "4px",
    border: "1px solid gray",
    fontSize: "14px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}>S. No</th>
            <th style={header}>
              Name of the trade and industry chambers/ associations
            </th>
            <th style={header}>
              Reach of trade and industry chambers/ associations
              <br />
              (State/National)
            </th>
          </tr>
        </thead>
        <tbody>
          {associations.map((row, index) => (
            <tr key={index}>
              <td style={cell}>{index + 1}.</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Name"
                  value={row.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Reach"
                  value={row.reach}
                  onChange={(e) => handleChange(index, "reach", e.target.value)}
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TradeAssociationsTable;
